import { Icon } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

export interface NodeSearchOptionProps {
  value: string;
  label: string;
  icon?: { type: string; name: string; className?: string };
  isActive?: boolean;
  onSelect: (item: { value: string; label: string }) => void;
  onMouseEnter?: () => void;
  id?: string;
  ref?: React.Ref<HTMLDivElement>;
}

export const NodeSearchOption = ({
  value,
  label,
  icon,
  isActive,
  onSelect,
  onMouseEnter,
  id,
  ref,
}: NodeSearchOptionProps) => {
  return (
    <div
      ref={ref}
      id={id}
      role="option"
      aria-selected={isActive}
      className={cn(
        "rounded-lg cursor-pointer text-body relative flex items-center gap-2 py-2 px-3 text-sm outline-none select-none",
        isActive
          ? "bg-neutral-object-accent-silent"
          : "hover:bg-neutral-object-accent-silent",
      )}
      onClick={() => onSelect({ value, label })}
      onMouseEnter={onMouseEnter}
    >
      <div className="w-full flex items-center gap-3">
        {icon && (
          <Icon type={icon.type} name={icon.name} className={icon.className} />
        )}
        <p className="font-semibold text-body truncate">{label}</p>
      </div>
    </div>
  );
};
